// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: NYeibxDv3Ojc
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  initializeCodeComponentStates,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import TextInput from "../../TextInput"; // plasmic-import: MFZnU9Tu3sPP/component
import { Password } from "@plasmicpkgs/antd/skinny/registerInput";
import { inputHelpers as Password_Helpers } from "@plasmicpkgs/antd/skinny/registerInput";
import Button from "../../Button"; // plasmic-import: CLyiSGaOpklv/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicApplicationKeys.module.css"; // plasmic-import: NYeibxDv3Ojc/css
import SearchSvgIcon from "./icons/PlasmicIcon__SearchSvg"; // plasmic-import: f7JkhShWWzGI/icon
import Layer11Icon from "./icons/PlasmicIcon__Layer11"; // plasmic-import: z3YAObc8gkKH/icon

createPlasmicElementProxy;

export const PlasmicApplicationKeys__VariantProps = new Array();

export const PlasmicApplicationKeys__ArgProps = new Array();

const $$ = {};

function PlasmicApplicationKeys__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "appId.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "apiKey.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ``,
        onMutate: generateOnMutateForSpec("value", Password_Helpers)
      },
      {
        path: "clientKey.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "webHookKey.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "devClientKey.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "devWebHookKey.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (
    <div
      data-plasmic-name={"rectangle"}
      data-plasmic-override={overrides.rectangle}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.rectangle
      )}
    >
      <div
        data-plasmic-name={"leftSide"}
        data-plasmic-override={overrides.leftSide}
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.leftSide
        )}
      >
        <React.Fragment>
          <React.Fragment>{""}</React.Fragment>
          {
            <h4
              data-plasmic-name={"h4"}
              data-plasmic-override={overrides.h4}
              className={classNames(
                projectcss.all,
                projectcss.h4,
                projectcss.__wab_text,
                sty.h4
              )}
            >
              <React.Fragment>
                <React.Fragment>{"Application Keys\n"}</React.Fragment>
                {
                  <blockquote
                    data-plasmic-name={"blockquote"}
                    data-plasmic-override={overrides.blockquote}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.blockquote
                    )}
                  >
                    <React.Fragment>
                      <React.Fragment>{""}</React.Fragment>
                      {
                        <span
                          data-plasmic-name={"span"}
                          data-plasmic-override={overrides.span}
                          className={classNames(
                            projectcss.all,
                            projectcss.span,
                            projectcss.__wab_text,
                            projectcss.plasmic_default__inline,
                            sty.span
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ fontWeight: 300 }}
                            >
                              {
                                "Your App ID and API key are used to identify your application when making requests with the Astrius Unify endpoints, as described in our documentation."
                              }
                            </span>
                          </React.Fragment>
                        </span>
                      }

                      <React.Fragment>{""}</React.Fragment>
                    </React.Fragment>
                  </blockquote>
                }

                <React.Fragment>{""}</React.Fragment>
              </React.Fragment>
            </h4>
          }

          <React.Fragment>{""}</React.Fragment>
        </React.Fragment>
      </div>
      <div
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.text__dfqoj
        )}
      >
        {"App ID"}
      </div>
      <TextInput
        data-plasmic-name={"appId"}
        data-plasmic-override={overrides.appId}
        aria-labelledby={``}
        className={classNames("__wab_instance", sty.appId)}
        onChange={async (...eventArgs) => {
          ((...eventArgs) => {
            generateStateOnChangeProp($state, ["appId", "value"])(
              (e => e.target?.value).apply(null, eventArgs)
            );
          }).apply(null, eventArgs);
          if (
            eventArgs.length > 1 &&
            eventArgs[1] &&
            eventArgs[1]._plasmic_state_init_
          ) {
            return;
          }
        }}
        startIcon={
          <SearchSvgIcon
            data-plasmic-name={"svg"}
            data-plasmic-override={overrides.svg}
            className={classNames(projectcss.all, sty.svg)}
            role={"img"}
          />
        }
        type={"text"}
        value={generateStateValueProp($state, ["appId", "value"]) ?? ""}
      />

      <div
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.text___1RA
        )}
      >
        {"API Key"}
      </div>
      <Stack__
        as={"div"}
        hasGap={true}
        className={classNames(projectcss.all, sty.freeBox__dClnz)}
      >
        {(() => {
          const child$Props = {
            allowClear: false,
            "aria-label": ``,
            className: classNames("__wab_instance", sty.apiKey),
            disabled: false,
            onChange: async (...eventArgs) => {
              generateStateOnChangePropForCodeComponents(
                $state,
                "value",
                ["apiKey", "value"],
                Password_Helpers
              ).apply(null, eventArgs);
            },
            type: ``,
            value: generateStateValueProp($state, ["apiKey", "value"]),
            visibilityToggle: true
          };
          initializeCodeComponentStates(
            $state,
            [
              {
                name: "value",
                plasmicStateName: "apiKey.value"
              }
            ],

            [],
            Password_Helpers ?? {},
            child$Props
          );
          return (
            <Password
              data-plasmic-name={"apiKey"}
              data-plasmic-override={overrides.apiKey}
              {...child$Props}
            />
          );
        })()}
        <Layer11Icon
          data-plasmic-name={"copyKey"}
          data-plasmic-override={overrides.copyKey}
          className={classNames(projectcss.all, sty.copyKey)}
          role={"img"}
        />
      </Stack__>
      <div className={classNames(projectcss.all, sty.freeBox__dtwTy)}>
        <div
          data-plasmic-name={"forProduction"}
          data-plasmic-override={overrides.forProduction}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.forProduction
          )}
        >
          <React.Fragment>
            <React.Fragment>{""}</React.Fragment>
            {
              <h5
                className={classNames(
                  projectcss.all,
                  projectcss.h5,
                  projectcss.__wab_text,
                  sty.h5__qpDiR
                )}
              >
                <React.Fragment>
                  <span
                    className={"plasmic_default__all plasmic_default__span"}
                    style={{ fontWeight: 700 }}
                  >
                    {"Production"}
                  </span>
                </React.Fragment>
              </h5>
            }

            <React.Fragment>{""}</React.Fragment>
          </React.Fragment>
        </div>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__tcARa
          )}
        >
          {"WebHook Client Key"}
        </div>
        <TextInput
          data-plasmic-name={"clientKey"}
          data-plasmic-override={overrides.clientKey}
          className={classNames("__wab_instance", sty.clientKey)}
          onChange={async (...eventArgs) => {
            ((...eventArgs) => {
              generateStateOnChangeProp($state, ["clientKey", "value"])(
                (e => e.target?.value).apply(null, eventArgs)
              );
            }).apply(null, eventArgs);
            if (
              eventArgs.length > 1 &&
              eventArgs[1] &&
              eventArgs[1]._plasmic_state_init_
            ) {
              return;
            }
          }}
          placeholder={"WebHook Client Key"}
          value={generateStateValueProp($state, ["clientKey", "value"]) ?? ""}
        />

        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__k94F6
          )}
        >
          {"Webhook Url"}
        </div>
        <TextInput
          data-plasmic-name={"webHookKey"}
          data-plasmic-override={overrides.webHookKey}
          className={classNames("__wab_instance", sty.webHookKey)}
          onChange={async (...eventArgs) => {
            ((...eventArgs) => {
              generateStateOnChangeProp($state, ["webHookKey", "value"])(
                (e => e.target?.value).apply(null, eventArgs)
              );
            }).apply(null, eventArgs);
            if (
              eventArgs.length > 1 &&
              eventArgs[1] &&
              eventArgs[1]._plasmic_state_init_
            ) {
              return;
            }
          }}
          placeholder={"WebHook Url"}
          value={generateStateValueProp($state, ["webHookKey", "value"]) ?? ""}
        />
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__mfRmY)}>
        <div
          data-plasmic-name={"forDevelopment"}
          data-plasmic-override={overrides.forDevelopment}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.forDevelopment
          )}
        >
          <React.Fragment>
            <React.Fragment>{""}</React.Fragment>
            {
              <h5
                className={classNames(
                  projectcss.all,
                  projectcss.h5,
                  projectcss.__wab_text,
                  sty.h5___9GJsT
                )}
              >
                <React.Fragment>
                  <span
                    className={"plasmic_default__all plasmic_default__span"}
                    style={{ fontWeight: 700 }}
                  >
                    {"Development"}
                  </span>
                </React.Fragment>
              </h5>
            }

            <React.Fragment>{""}</React.Fragment>
          </React.Fragment>
        </div>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__fH4Nb
          )}
        >
          {"WebHook Client Key"}
        </div>
        <TextInput
          data-plasmic-name={"devClientKey"}
          data-plasmic-override={overrides.devClientKey}
          className={classNames("__wab_instance", sty.devClientKey)}
          onChange={async (...eventArgs) => {
            ((...eventArgs) => {
              generateStateOnChangeProp($state, ["devClientKey", "value"])(
                (e => e.target?.value).apply(null, eventArgs)
              );
            }).apply(null, eventArgs);
            if (
              eventArgs.length > 1 &&
              eventArgs[1] &&
              eventArgs[1]._plasmic_state_init_
            ) {
              return;
            }
          }}
          placeholder={"WebHook Client Key"}
          value={
            generateStateValueProp($state, ["devClientKey", "value"]) ?? ""
          }
        />

        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__m89O8
          )}
        >
          {"Webhook Url"}
        </div>
        <TextInput
          data-plasmic-name={"devWebHookKey"}
          data-plasmic-override={overrides.devWebHookKey}
          className={classNames("__wab_instance", sty.devWebHookKey)}
          onChange={async (...eventArgs) => {
            ((...eventArgs) => {
              generateStateOnChangeProp($state, ["devWebHookKey", "value"])(
                (e => e.target?.value).apply(null, eventArgs)
              );
            }).apply(null, eventArgs);
            if (
              eventArgs.length > 1 &&
              eventArgs[1] &&
              eventArgs[1]._plasmic_state_init_
            ) {
              return;
            }
          }}
          placeholder={"WebHook Url"}
          value={
            generateStateValueProp($state, ["devWebHookKey", "value"]) ?? ""
          }
        />
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__iH0N)}>
        <Button
          data-plasmic-name={"regenerateApiKey"}
          data-plasmic-override={overrides.regenerateApiKey}
          className={classNames("__wab_instance", sty.regenerateApiKey)}
        >
          {"Generate API Key"}
        </Button>
        <Button
          data-plasmic-name={"addKeys"}
          data-plasmic-override={overrides.addKeys}
          className={classNames("__wab_instance", sty.addKeys)}
        >
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__fcYxt
            )}
          >
            {"Add Webhook"}
          </div>
        </Button>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  rectangle: [
    "rectangle",
    "leftSide",
    "h4",
    "blockquote",
    "span",
    "appId",
    "svg",
    "apiKey",
    "copyKey",
    "forProduction",
    "clientKey",
    "webHookKey",
    "forDevelopment",
    "devClientKey",
    "devWebHookKey",
    "regenerateApiKey",
    "addKeys"
  ],

  leftSide: ["leftSide", "h4", "blockquote", "span"],
  h4: ["h4", "blockquote", "span"],
  blockquote: ["blockquote", "span"],
  span: ["span"],
  appId: ["appId", "svg"],
  svg: ["svg"],
  apiKey: ["apiKey"],
  copyKey: ["copyKey"],
  forProduction: ["forProduction"],
  clientKey: ["clientKey"],
  webHookKey: ["webHookKey"],
  forDevelopment: ["forDevelopment"],
  devClientKey: ["devClientKey"],
  devWebHookKey: ["devWebHookKey"],
  regenerateApiKey: ["regenerateApiKey"],
  addKeys: ["addKeys"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicApplicationKeys__ArgProps,
          internalVariantPropNames: PlasmicApplicationKeys__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicApplicationKeys__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "rectangle") {
    func.displayName = "PlasmicApplicationKeys";
  } else {
    func.displayName = `PlasmicApplicationKeys.${nodeName}`;
  }
  return func;
}

export const PlasmicApplicationKeys = Object.assign(
  // Top-level PlasmicApplicationKeys renders the root element
  makeNodeComponent("rectangle"),
  {
    // Helper components rendering sub-elements
    leftSide: makeNodeComponent("leftSide"),
    h4: makeNodeComponent("h4"),
    blockquote: makeNodeComponent("blockquote"),
    span: makeNodeComponent("span"),
    appId: makeNodeComponent("appId"),
    svg: makeNodeComponent("svg"),
    apiKey: makeNodeComponent("apiKey"),
    copyKey: makeNodeComponent("copyKey"),
    forProduction: makeNodeComponent("forProduction"),
    clientKey: makeNodeComponent("clientKey"),
    webHookKey: makeNodeComponent("webHookKey"),
    forDevelopment: makeNodeComponent("forDevelopment"),
    devClientKey: makeNodeComponent("devClientKey"),
    devWebHookKey: makeNodeComponent("devWebHookKey"),
    regenerateApiKey: makeNodeComponent("regenerateApiKey"),
    addKeys: makeNodeComponent("addKeys"),
    // Metadata about props expected for PlasmicApplicationKeys
    internalVariantProps: PlasmicApplicationKeys__VariantProps,
    internalArgProps: PlasmicApplicationKeys__ArgProps
  }
);

export default PlasmicApplicationKeys;
/* prettier-ignore-end */
